import { getInclusionOptions } from '../logicHelpers'

const wordpressSource = () => {
  return {
    types: [
      { label: 'Current page', value: 'current-pageId' },
      { label: 'Current post', value: 'current-postId' },
      { label: "Current post's tags", value: 'current-taxonomy-post_tag' },
      {
        label: "Current post's category",
        value: 'current-taxonomy-category'
      },
      { label: 'Favorite tag', value: 'favorite-taxonomy-post_tag' },
      { label: 'Favorite category', value: 'favorite-taxonomy-category' }
    ],
    inputs: [
      {
        $formkit: 'select',
        key: 'operator-select',
        name: 'operator',
        options: getInclusionOptions(),
        can: (condition: { $source: string }) =>
          condition.$source === 'wordpress'
      },
      {
        $formkit: 'autocomplete',
        key: 'value-select-page',
        name: 'value',
        options: async () => {
          const data = await getIntegrationData('wordpress', 'pages')
          return data.value.map((page) => ({
            label: page.caption,
            value: String(page.id)
          }))
        },
        multiple: true,
        can: (condition: {
          $source: string
          operator: string
          $type: string
        }) =>
          condition.$source === 'wordpress' &&
          condition.$type === 'current-pageId'
      },
      {
        $formkit: 'autocomplete',
        key: 'value-select-post',
        name: 'value',
        options: async () => {
          const data = await getIntegrationData('wordpress', 'posts')
          return data.value.map((page) => ({
            label: page.caption,
            value: String(page.id)
          }))
        },
        multiple: true,
        can: (condition: {
          $source: string
          operator: string
          $type: string
        }) =>
          condition.$source === 'wordpress' &&
          condition.$type === 'current-postId'
      },
      {
        $formkit: 'autocomplete',
        key: 'value-select-post-tags',
        name: 'value',
        options: async () => {
          const data = await getIntegrationData('wordpress', 'taxonomies')
          const tags =
            data.value.find((tax) => tax.id === 'post_tag')?.terms || []
          return tags.map((page) => ({
            label: page.caption,
            value: String(page.id)
          }))
        },
        multiple: true,
        can: (condition: {
          $source: string
          operator: string
          $type: string
        }) =>
          condition.$source === 'wordpress' &&
          condition.$type === 'current-taxonomy-post_tag'
      },
      {
        $formkit: 'autocomplete',
        key: 'value-select-categories',
        name: 'value',
        options: async () => {
          const data = await getIntegrationData('wordpress', 'taxonomies')
          const categories =
            data.value.find((tax) => tax.id === 'category')?.terms || []
          return categories.map((page) => ({
            label: page.caption,
            value: String(page.id)
          }))
        },
        multiple: true,
        can: (condition: {
          $source: string
          operator: string
          $type: string
        }) =>
          condition.$source === 'wordpress' &&
          condition.$type === 'current-taxonomy-category'
      },
      {
        $formkit: 'autocomplete',
        key: 'value-select-favorite-tags',
        name: 'value',
        options: async () => {
          const data = await getIntegrationData('wordpress', 'taxonomies')
          const tags =
            data.value.find((tax) => tax.id === 'post_tag')?.terms || []
          return tags.map((page) => ({
            label: page.caption,
            value: String(page.id)
          }))
        },
        multiple: true,
        can: (condition: {
          $source: string
          operator: string
          $type: string
        }) =>
          condition.$source === 'wordpress' &&
          condition.$type === 'favorite-taxonomy-post_tag'
      },
      {
        $formkit: 'autocomplete',
        key: 'value-favorite-categories',
        name: 'value',
        options: async () => {
          const data = await getIntegrationData('wordpress', 'taxonomies')
          const categories =
            data.value.find((tax) => tax.id === 'category')?.terms || []
          return categories.map((page) => ({
            label: page.caption,
            value: String(page.id)
          }))
        },
        multiple: true,
        can: (condition: {
          $source: string
          operator: string
          $type: string
        }) =>
          condition.$source === 'wordpress' &&
          condition.$type === 'favorite-taxonomy-category'
      }
      // {
      //   $formkit: 'text',
      //   key: 'value-input',
      //   name: 'value',
      //   can: (condition: { $source: string; operator: string }) =>
      //     condition.$source === 'utm' &&
      //     condition.operator !== 'is set' &&
      //     condition.operator !== 'is not set'
      // }
    ]
  }
}

export default wordpressSource

// import { FormKitSchemaNode } from '@formkit/core'

// const wordpressSource: FormKitSchemaNode = {
//   $formkit: 'group',
//   name: 'wordpress',
//   label: 'WordPress',
//   children: [
//     {
//       $formkit: 'select',
//       name: 'type',
//       label: 'WordPress Type',
//       options: [
//         { label: 'Current page', value: 'current-pageId' },
//         { label: 'Current post', value: 'current-postId' },
//         { label: "Current post's tags", value: 'current-taxonomy-post_tag' },
//         {
//           label: "Current post's category",
//           value: 'current-taxonomy-category'
//         },
//         { label: 'Favorite tag', value: 'favorite-taxonomy-post_tag' },
//         { label: 'Favorite category', value: 'favorite-taxonomy-category' }
//       ]
//     },
//     {
//       $formkit: 'select',
//       name: 'operator',
//       label: 'Operator',
//       options: [
//         { label: 'Is any of', value: 'include any' },
//         { label: "Isn't any of", value: 'do not include any' }
//       ]
//     },
//     {
//       $formkit: 'select',
//       name: 'value',
//       label: 'Value',
//       options: [], // This should be populated dynamically based on the selected type
//       attrs: {
//         multiple: true
//       }
//     }
//   ]
// }

// export default wordpressSource
